jQuery(function ($) {
	const Scripts = {
		varInit() {
			this.header = $('header');
			this.document = $(document);

			this.activeTooltip = null;
			this.hideTimer = null;
		},

		setTopBarHeight() {
			const $topBar = $('.top-bar');

			const update = () => {
				const height = $topBar.length ? $topBar.outerHeight() : 0;
				document.documentElement.style.setProperty('--top-bar-height', height + 'px');
			};

			update();

			$(window).on('resize', update);
		},

		stickyHeader() {
			const $header = this.header;
			const $body = $('body');
			const headerHeight = $header.outerHeight();

			const SCROLL_THRESHOLD_DESKTOP = 1000;
			const SCROLL_THRESHOLD_MOBILE = 800;
			const MOBILE_BREAKPOINT = 767;

			let isSticky = false;

			const getThreshold = () => {
				return window.innerWidth <= MOBILE_BREAKPOINT
					? SCROLL_THRESHOLD_MOBILE
					: SCROLL_THRESHOLD_DESKTOP;
			};

			const makeSticky = () => {
				if (isSticky) return;
				isSticky = true;

				$body.css('padding-top', headerHeight + 'px');
				document.documentElement.style.setProperty('--menu-offset', headerHeight + 'px');
				$header
					.css({ transform: 'translateY(-100%)', transition: 'none' })
					.addClass('is-sticky');

				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						$header.css({ transition: 'transform 0.3s ease', transform: 'translateY(0)' });
					});
				});
			};

			const makeStatic = () => {
				if (!isSticky) return;
				isSticky = false;

				$header.css({ transform: '', transition: '' }).removeClass('is-sticky');
				$body.css('padding-top', '');
				document.documentElement.style.removeProperty('--menu-offset');
			};

			$(window).on('scroll', function () {
				const scrollY = window.scrollY;
				const threshold = getThreshold();

				if (scrollY >= threshold && !isSticky) {
					makeSticky();
				} else if (scrollY < threshold && isSticky) {
					makeStatic();
				}
			});

			if (window.scrollY >= getThreshold()) {
				$header.addClass('is-sticky');
				$body.css('padding-top', headerHeight + 'px');
				document.documentElement.style.setProperty('--menu-offset', headerHeight + 'px');
				isSticky = true;
			}
		},

		scrollProgressBar() {
			const $header = this.header;
			if (!$header.length) return;

			let ticking = false;

			const updateProgress = () => {
				const scrollTop = $(window).scrollTop();
				const docHeight = $(document).height() - $(window).height();

				if (docHeight <= 0) {
					$header[0].style.setProperty('--scroll-progress', '0%');
					ticking = false;
					return;
				}

				const progress = Math.min(Math.max((scrollTop / docHeight) * 100, 0), 100);
				$header[0].style.setProperty('--scroll-progress', progress + '%');

				ticking = false;
			};

			const onScroll = () => {
				if (ticking) return;
				ticking = true;
				requestAnimationFrame(updateProgress);
			};

			$(window).on('scroll resize', onScroll);
			updateProgress();
		},

		scrollToTopBtn() {
			const $btn = $('#scroll-to-top');
			if (!$btn.length) return;

			const btnEl = $btn[0];
			const topLayer = btnEl.querySelector('.scroll-to-top__layer--top');
			if (!topLayer) return;

			const SCROLL_THRESHOLD_DESKTOP = 1000;
			const SCROLL_THRESHOLD_MOBILE = 800;
			const MOBILE_BREAKPOINT = 767;

			const getThreshold = () => {
				return window.innerWidth <= MOBILE_BREAKPOINT
					? SCROLL_THRESHOLD_MOBILE
					: SCROLL_THRESHOLD_DESKTOP;
			};

			// Перерахунок clip-path верхнього шару:
			// показуємо тільки ті вертикальні смуги, що зараз перекриті темними секціями.
			const updateClipPath = () => {
				const btnRect = btnEl.getBoundingClientRect();
				const btnHeight = btnRect.height;
				if (btnHeight <= 0) return;

				const darkEls = document.querySelectorAll('.dark-section');
				if (!darkEls.length) {
					topLayer.style.clipPath = 'inset(100% 0 0 0)';
					return;
				}

				// Збираємо інтервали по вертикалі (відносно кнопки), де знаходяться темні секції
				const intervals = [];
				darkEls.forEach((el) => {
					const r = el.getBoundingClientRect();
					// Перетин по вертикалі з кнопкою
					const top = Math.max(r.top, btnRect.top);
					const bottom = Math.min(r.bottom, btnRect.bottom);
					if (bottom > top) {
						intervals.push([top - btnRect.top, bottom - btnRect.top]);
					}
				});

				if (!intervals.length) {
					topLayer.style.clipPath = 'inset(100% 0 0 0)';
					return;
				}

				// Зливаємо інтервали, що перекриваються
				intervals.sort((a, b) => a[0] - b[0]);
				const merged = [intervals[0]];
				for (let i = 1; i < intervals.length; i++) {
					const last = merged[merged.length - 1];
					const cur = intervals[i];
					if (cur[0] <= last[1]) {
						last[1] = Math.max(last[1], cur[1]);
					} else {
						merged.push(cur);
					}
				}

				// Якщо темна секція покриває кнопку повністю — просто показуємо весь шар
				if (merged.length === 1 && merged[0][0] <= 0 && merged[0][1] >= btnHeight) {
					topLayer.style.clipPath = 'inset(0 0 0 0)';
					return;
				}

				// Будуємо polygon з прямокутників-смуг
				const points = [];
				merged.forEach(([top, bottom]) => {
					const t = (Math.max(0, top) / btnHeight) * 100;
					const b = (Math.min(btnHeight, bottom) / btnHeight) * 100;
					points.push(`0% ${t}%`, `100% ${t}%`, `100% ${b}%`, `0% ${b}%`);
				});

				topLayer.style.clipPath = `polygon(${points.join(', ')})`;
			};

			let ticking = false;
			const onScroll = () => {
				if (ticking) return;
				ticking = true;
				requestAnimationFrame(() => {
					const isVisible = window.scrollY >= getThreshold();
					$btn.toggleClass('is-visible', isVisible);
					if (isVisible) updateClipPath();
					ticking = false;
				});
			};

			$btn.on('click', function (e) {
				e.preventDefault();
				$('html, body').stop().animate({ scrollTop: 0 }, 600, 'swing');
			});

			$(window).on('scroll', onScroll);
			$(window).on('resize', onScroll);

			onScroll();
		},

		headerOverlays() {
			const $body         = $('body');
			const $overlay      = $('#search-overlay');
			const $globalPopup  = $('#search-popup');
			const $archivePopup = $('#search-archive-popup');
			const $mobileMenu   = $('#mobile-menu');
			const $globalBtn    = $('#search-btn');
			const $archiveBtn   = $('#search-archive-btn');
			const $menuBtn      = $('#mobile-menu-btn');

			if (!$globalPopup.length && !$archivePopup.length && !$mobileMenu.length) return;

			// 'global' | 'archive' | 'menu' | null
			let activePopup = null;

			// const getScrollbarWidth = () => {
			// 	return window.innerWidth - document.documentElement.clientWidth;
			// };

			// const lockScroll = () => {
			// 	if ($body.hasClass('is-search-open')) return;

			// 	const scrollbarWidth = getScrollbarWidth();
			// 	if (scrollbarWidth > 0) {
			// 		$body.css('padding-right', scrollbarWidth + 'px');
			// 		$('.header.is-sticky').css('padding-right', scrollbarWidth + 'px');
			// 	}
			// 	$body.addClass('is-search-open');
			// };

			// const unlockScroll = () => {
			// 	$body.removeClass('is-search-open');
			// 	$body.css('padding-right', '');
			// 	$('.header').css('padding-right', '');
			// };

			const lockScroll = () => {
				if ($body.hasClass('is-search-open')) return;
				$body.addClass('is-search-open');
			};

			const unlockScroll = () => {
				$body.removeClass('is-search-open');
			};

			const getPopup = (type) => {
				if (type === 'archive') return $archivePopup;
				if (type === 'menu')    return $mobileMenu;
				return $globalPopup;
			};

			const getBtn = (type) => {
				if (type === 'archive') return $archiveBtn;
				if (type === 'menu')    return $menuBtn;
				return $globalBtn;
			};

			// ВАЖЛИВО: показ робимо через Promise, щоб дочекатись приховування попереднього
			const showPopup = (type) => {
				const $popup = getPopup(type);
				const $btn   = getBtn(type);

				$overlay.addClass('is-open').attr('aria-hidden', 'false');
				$popup.addClass('is-open').attr('aria-hidden', 'false');
				$btn.attr('aria-expanded', 'true');

				if (type === 'menu') {
					$btn.addClass('is-active');
				}

				activePopup = type;

				// фокус на інпут лише для пошукових типів
				if (type !== 'menu') {
					setTimeout(() => {
						$popup.find('input[type="search"]').trigger('focus');
					}, 350);
				}
			};

			const hidePopup = (type, keepOverlay = false) => {
				const $popup = getPopup(type);
				const $btn   = getBtn(type);

				$popup.removeClass('is-open').attr('aria-hidden', 'true');
				$btn.attr('aria-expanded', 'false');

				if (type === 'menu') {
					$btn.removeClass('is-active');
				}

				if (!keepOverlay) {
					$overlay.removeClass('is-open').attr('aria-hidden', 'true');
				}
			};

			// Чекаємо завершення transition на конкретному попапі, потім викликаємо callback
			const waitTransition = ($popup, callback) => {
				// тривалість transform у CSS — найдовша (.4s). Беремо з запасом.
				const FALLBACK = 420;
				let done = false;

				const finish = () => {
					if (done) return;
					done = true;
					$popup.off('transitionend.overlaySwitch');
					callback();
				};

				$popup.on('transitionend.overlaySwitch', (e) => {
					// ловимо тільки transform/opacity, щоб не реагувати на дочірні
					if (e.target !== $popup[0]) return;
					if (e.originalEvent.propertyName !== 'transform' &&
						e.originalEvent.propertyName !== 'opacity') return;
					finish();
				});

				setTimeout(finish, FALLBACK);
			};

			const openPopup = (type) => {
				// якщо клік по тій самій — закриваємо
				if (activePopup === type) {
					closePopup();
					return;
				}

				// якщо щось відкрите — спочатку повністю ховаємо це, потім вже відкриваємо нове
				if (activePopup) {
					const $prev = getPopup(activePopup);
					const prevType = activePopup;

					hidePopup(prevType, true); // оверлей лишаємо
					waitTransition($prev, () => {
						showPopup(type);
					});
				} else {
					lockScroll();
					showPopup(type);
				}
			};

			const closePopup = () => {
				if (!activePopup) return;

				// Очищаємо інпут лише для пошукових
				if (activePopup !== 'menu') {
					getPopup(activePopup).find('input[type="search"]').val('');
				}

				hidePopup(activePopup);
				activePopup = null;
				unlockScroll();
			};

			// Плавний скрол наверх і callback після зупинки
			const scrollToTopThen = (callback) => {
				if (window.scrollY === 0) {
					callback();
					return;
				}

				let called = false;
				const runOnce = () => {
					if (called) return;
					called = true;
					requestAnimationFrame(callback);
				};

				$('html, body').stop().animate({ scrollTop: 0 }, 400, 'swing', runOnce);
			};

			// --- Глобальний пошук ---
			$globalBtn.on('click', function (e) {
				e.preventDefault();
				openPopup('global');
			});

			// --- Архівний пошук ---
			$archiveBtn.on('click', function (e) {
				e.preventDefault();
				if (!$archivePopup.length) return;

				if (activePopup === 'archive') {
					closePopup();
					return;
				}

				scrollToTopThen(() => openPopup('archive'));
			});

			// --- Мобільне меню ---
			$menuBtn.on('click', function (e) {
				e.preventDefault();
				if (!$mobileMenu.length) return;

				if (activePopup === 'menu') {
					closePopup();
					return;
				}

				// Якщо хедер ще не зафіксований — спочатку доскролюємо вгору,
				// щоб топ-бар і хедер були на своїх місцях і не було зазору під меню.
				// Якщо хедер вже sticky — відкриваємо одразу, не чіпаючи скрол.
				if (!Scripts.header.hasClass('is-sticky')) {
					scrollToTopThen(() => openPopup('menu'));
				} else {
					openPopup('menu');
				}
			});

			// --- Закриття по крестику (всередині пошукових попапів) ---
			$(document).on('click', '.js-search-close', function (e) {
				e.preventDefault();
				closePopup();
			});

			// --- Закриття по оверлею ---
			$overlay.on('click', closePopup);

			// --- Закриття по Esc ---
			$(document).on('keydown', function (e) {
				if (e.key === 'Escape' && activePopup) {
					closePopup();
				}
			});
		},

		mobileSubmenu() {
			$(document).on('click', '.menu-mobile .submenu-arrow', function (e) {
				e.preventDefault();
				e.stopPropagation();
				const $li = $(this).closest('.menu-item-has-children');
				const expanded = $li.attr('aria-expanded') === 'true';
				$li.attr('aria-expanded', expanded ? 'false' : 'true');
			});
		},

		// =============================================================================
		// menuHashActiveState — коригує підсвітку активних пунктів меню з урахуванням
		// search+hash. WP бачить лише pathname, тому пункти на один шлях, але з різним
		// хешем/запитом (/trainings/, /trainings/#center, /trainings/#projects) він
		// підсвічує всі. Тут активним лишаємо той пункт, чиє посилання точно збіглось
		// із поточним search+hash; батько активний, якщо активний він сам АБО нащадок.
		// Якщо точного збігу немає — активним стає «власник» чистого шляху (без хеша).
		// =============================================================================

		menuHashActiveState() {
			const $menu = $('#menu-header');
			if (!$menu.length) return;

			const ACTIVE = 'current-menu-item current-menu-parent current-menu-ancestor';
			const stripSlash = (s) => (s || '').replace(/\/+$/, '') || '/';
			const linkKey = (a) => a.search + a.hash; // '', '#center', '?training-type=courses#courses'

			const refresh = () => {
				const curPath = stripSlash(location.pathname);
				const curKey  = location.search + location.hash;

				// Усі посилання меню, що ведуть на поточний шлях (без урахування search/hash).
				const pathLinks = $menu.find('a[href]').toArray()
					.filter((a) => stripSlash(a.pathname) === curPath);

				if (!pathLinks.length) return; // нема на що впливати — лишаємо вивід WP

				// Чи є серед них точний збіг по search+hash.
				const exactExists = pathLinks.some((a) => linkKey(a) === curKey);

				const isSelfActive = (a) =>
					pathLinks.indexOf(a) !== -1 &&
					(exactExists ? linkKey(a) === curKey : linkKey(a) === '');

				// Обробляємо лише пункти, дотичні до поточної сторінки (мають посилання
				// на цей шлях у себе або в нащадках). Решту не чіпаємо.
				$menu.find('.menu-item').each(function () {
					const $item = $(this);
					const itemLinks = $item.find('a[href]').toArray()
						.filter((a) => stripSlash(a.pathname) === curPath);
					if (!itemLinks.length) return;

					const ownLink   = $item.children('a[href]')[0] || null;
					const ownActive = ownLink ? isSelfActive(ownLink) : false;
					const anyActive = itemLinks.some(isSelfActive); // власне АБО нащадок

					$item.toggleClass(ACTIVE, anyActive);

					// aria-current — лише на власному посиланні пункта, якщо саме воно активне.
					if (ownLink) {
						$(ownLink).attr('aria-current', ownActive ? 'page' : null);
					}
				});
			};

			refresh();
			$(window).on('hashchange', refresh);
		},

		initCompendiumSearch() {
			const $popup = $('#search-archive-popup.header-search--compendium');
			if (!$popup.length) return;

			const $sourceGrid = $('.osint-grid');
			if (!$sourceGrid.length) return;

			const $resultsContainer = $popup.find('.js-compendium-search-results');
			const $emptyBlock = $popup.find('.js-compendium-search-empty');
			const $form = $popup.find('.js-compendium-search-form');
			const $input = $popup.find('.js-compendium-search-input');
			const $archiveBtn = $('#search-archive-btn');

			let isCloned = false;
			let $clonedGrid = null;
			let $clonedCards = null;

			const cloneGridIfNeeded = () => {
				if (isCloned) return;

				$clonedGrid = $sourceGrid.clone();
				$clonedGrid.find('.osint-card').removeClass('is-hidden');

				$resultsContainer.append($clonedGrid);
				$clonedCards = $clonedGrid.find('.osint-card');
				isCloned = true;

				// Одразу ховаємо — бо поки нічого не введено
				$clonedGrid.hide();
			};

			const filterCards = (query) => {
				if (!$clonedCards || !$clonedCards.length) return;

				const q = query.trim().toLowerCase();

				if (!q) {
					$clonedGrid.hide();
					$emptyBlock.prop('hidden', true);
					$popup.removeClass('is-expanded');
					return;
				}

				let matchCount = 0;

				$clonedCards.each(function () {
					const text = this.textContent.toLowerCase();
					const match = text.indexOf(q) !== -1;

					$(this).toggleClass('is-search-hidden', !match);
					if (match) matchCount++;
				});

				if (matchCount > 0) {
					$clonedGrid.show();
					$emptyBlock.prop('hidden', true);
					$popup.addClass('is-expanded');
				} else {
					$clonedGrid.hide();
					$emptyBlock.prop('hidden', false);
					$popup.removeClass('is-expanded');
				}
			};

			$archiveBtn.on('click', cloneGridIfNeeded);

			$form.on('submit', (e) => e.preventDefault());

			$input.on('input', function () {
				filterCards($(this).val());
			});

			// Скидаємо стан при закритті плашки
			const resetState = () => {
				$input.val('');
				if ($clonedGrid) $clonedGrid.hide();
				$emptyBlock.prop('hidden', true);
				$popup.removeClass('is-expanded');
			};

			// Слухаємо зміну класу is-open на плашці
			const observer = new MutationObserver(() => {
				if (!$popup.hasClass('is-open')) {
					resetState();
				}
			});

			observer.observe($popup[0], {
				attributes: true,
				attributeFilter: ['class']
			});

		},

		anchorScroll() {
			const DURATION_PER_PX = 0.4;
			const MAX_DURATION = 1200;
			const MIN_DURATION = 300;
			const EASING = 'swing';

			function getScrollDuration(targetOffset) {
				const distance = Math.abs(targetOffset - $(window).scrollTop());
				const duration = distance * DURATION_PER_PX;
				return Math.min(Math.max(duration, MIN_DURATION), MAX_DURATION);
			}

			function scrollToTarget(hash) {
				const $target = $(hash);
				if (!$target.length) return;

				const headerHeight = Scripts.header.outerHeight() || 0;
				const threshold = window.innerWidth <= 767 ? 800 : 1000;
				const targetTop = $target.offset().top;

				const offset = (targetTop - headerHeight) >= threshold ? headerHeight : 0;

				const targetOffset = targetTop - offset;
				const duration = getScrollDuration(targetOffset);
				$('html, body').animate({ scrollTop: targetOffset }, duration, EASING);
			}

			// Плавний скрол на тій самій сторінці
			$(document).on('click', '.js-anchor-scroll', function (e) {
				const href = $(this).attr('href');
				if (!href) return;

				const hash = href.includes('#') ? '#' + href.split('#')[1] : null;
				if (!hash) return;

				if ($(hash).length) {
					e.preventDefault();
					scrollToTarget(hash);
					history.pushState(null, null, hash);
				}
			});

			// Скрол після завантаження з іншої сторінки
			if (window.location.hash) {
				const hash = window.location.hash;

				// Одразу скидаємо скрол в топ — до того як браузер встигне стрибнути
				$('html, body').scrollTop(0);

				// Забороняємо браузеру самому скролити до якоря
				if (history.scrollRestoration) {
					history.scrollRestoration = 'manual';
				}

				$(window).on('load', function () {
					setTimeout(function () {
						scrollToTarget(hash);
					}, 100);
				});
			}
		},

		tocFab() {
			const $fab = $('.th-toc-fab');
			if (!$fab.length) return;

			const $button = $fab.find('.th-toc-fab__button');
			const $closeBtn = $fab.find('.th-toc-fab__close');
			const $popup = $fab.find('.th-toc-fab__popup');

			if (!$button.length || !$popup.length) return;

			const open = () => {
				$fab.addClass('is-open').attr('aria-hidden', 'false');
				$button.attr('aria-expanded', 'true');
			};

			const close = () => {
				$fab.removeClass('is-open').attr('aria-hidden', 'true');
				$button.attr('aria-expanded', 'false');
			};

			const toggle = () => {
				if ($fab.hasClass('is-open')) {
					close();
				} else {
					open();
				}
			};

			// Клік по зеленій кнопці — тогл попапу.
			// stopPropagation щоб не спрацював document-клік нижче.
			$button.on('click', function (e) {
				e.stopPropagation();
				toggle();
			});

			// Клік по × — закрити.
			$closeBtn.on('click', function (e) {
				e.stopPropagation();
				close();
			});

			// Клік по посиланню в попапі — закриваємо.
			// Сам скрол з offset виконує метод anchorScroll() теми
			// (на посиланнях стоїть клас js-anchor-scroll).
			$popup.on('click', 'a', function () {
				close();
			});

			// Клік поза FAB — закрити.
			this.document.on('click', function (e) {
				if (!$fab.hasClass('is-open')) return;
				if (!$.contains($fab[0], e.target) && $fab[0] !== e.target) {
					close();
				}
			});
		},

		initHomeAreasHover() {

			if (window.innerWidth <= 1279 || window.matchMedia('(hover: none)').matches) {
				return;
			}

			const section = $('.home-areas');

			if (!section.length) return;

			const list = section.find('.js-home-areas-list');
			const items = section.find('.js-home-areas-item');
			const mediaItems = section.find('.js-home-areas-media-item');

			if (!list.length || !items.length || !mediaItems.length) return;

			let currentIndex = null;

			const showImage = (index) => {
				index = Number(index);

				if (currentIndex === index) return;

				currentIndex = index;

				mediaItems.removeClass('is-visible');
				mediaItems
					.filter('[data-area-index="' + index + '"]')
					.addClass('is-visible');
			};

			const resetImage = () => {
				showImage(0);
			};

			resetImage();

			items.on('mouseenter focus', function () {
				const index = $(this).data('area-index');
				showImage(index);
			});

			list.on('mouseleave', function () {
				resetImage();
			});

			list.on('focusout', function (e) {
				if (!list[0].contains(e.relatedTarget)) {
					resetImage();
				}
			});
		},

		counterInit() {
			this.counterEls = $('.js-counter');
			if (!this.counterEls.length) return;

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;

					const $counter = $(entry.target);

					if ($counter.hasClass('is-animated')) {
						observer.unobserve(entry.target);
						return;
					}

					this.animateCounter($counter);
					$counter.addClass('is-animated');
					observer.unobserve(entry.target);
				});
			}, {
				threshold: 0.4
			});

			this.counterEls.each(function() {
				observer.observe(this);
			});
		},

		animateCounter($counter) {
			const target = parseInt($counter.attr('data-counter-target'), 10) || 0;
			const suffix = $counter.attr('data-counter-suffix') || '';

			const formatNumber = (number) => {
				return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
			};

			// Числа от 0 до 9 не анимируем — сразу показываем результат
			if (target >= 0 && target <= 15) {
				$counter.text(formatNumber(target) + suffix);
				return;
			}

			const duration = 1600;
			const startTime = performance.now();

			const updateCounter = (currentTime) => {
				const elapsed = currentTime - startTime;
				const progress = Math.min(elapsed / duration, 1);

				// Плавніше, ніж просто лінійно
				const easedProgress = 1 - Math.pow(1 - progress, 3);
				const currentValue = Math.round(target * easedProgress);

				$counter.text(formatNumber(currentValue) + suffix);

				if (progress < 1) {
					requestAnimationFrame(updateCounter);
				} else {
					$counter.text(formatNumber(target) + suffix);
				}
			};

			requestAnimationFrame(updateCounter);
		},

		marqueeScrollInit() {
			this.marqueeEls = $('.js-marquee');

			if (!this.marqueeEls.length) return;

			this.marqueeItems = [];

			this.marqueeEls.each((index, el) => {
				const $marquee = $(el);
				const $track = $marquee.find('.js-marquee-track');

				if (!$track.length) return;

				const $items = $track.children().clone();
				$track.append($items);

				this.marqueeItems.push({
					$marquee,
					$track,
					currentX: 0,
					lastScrollY: window.scrollY,
					loopWidth: 0
				});
			});

			this.marqueeScrollUpdateSizes();

			$(window).on('resize', () => {
				this.marqueeScrollUpdateSizes();
			});

			$(window).on('scroll', () => {
				this.marqueeScrollUpdate();
			});
		},

		marqueeScrollUpdateSizes() {
			if (!this.marqueeItems || !this.marqueeItems.length) return;

			this.marqueeItems.forEach((item) => {
				item.loopWidth = item.$track[0].scrollWidth / 2;
			});
		},

		marqueeScrollUpdate() {
			if (!this.marqueeItems || !this.marqueeItems.length) return;

			const currentScrollY = window.scrollY;

			this.marqueeItems.forEach((item) => {
				const marqueeRect = item.$marquee[0].getBoundingClientRect();
				const windowHeight = window.innerHeight || document.documentElement.clientHeight;

				const isVisible = marqueeRect.bottom > 0 && marqueeRect.top < windowHeight;

				const delta = currentScrollY - item.lastScrollY;

				if (isVisible) {
					item.currentX -= delta * 0.8;

					if (item.loopWidth > 0) {
						if (item.currentX <= -item.loopWidth) {
							item.currentX += item.loopWidth;
						}

						if (item.currentX >= 0) {
							item.currentX -= item.loopWidth;
						}
					}

					item.$track.css('transform', `translate3d(${item.currentX}px, 0, 0)`);
				}

				item.lastScrollY = currentScrollY;
			});
		},

		homeAwardsSlider() {
			const awardsSlider = new Swiper('.awards-slider', {
				slidesPerView: 'auto',
				spaceBetween: 14,
				speed: 800,

				a11y: {
					slideRole: '',
					slideLabelMessage: '',
				},

				navigation: {
					nextEl: '.home-awards__arrow--next',
					prevEl: '.home-awards__arrow--prev',
				},

				breakpoints: {
					768: {
						slidesPerView: 'auto',
						spaceBetween: 24,
					},
					1280: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
				},
			});
		},

		initHomePartnersToggle() {
			const block = $('.home-partners');
			const toggleBtn = block.find('.js-home-partners-toggle');
			const toggleText = block.find('.home-partners__toggle-text');
			const items = block.find('.home-partners__item');

			const updateState = function () {
				if (window.innerWidth > 1279 || items.length <= 4) {
					block.removeClass('is-expanded');
					toggleBtn.attr('aria-expanded', 'false').hide();
					toggleText.text(themeTexts.partnersShow);
					return;
				}

				toggleBtn.css('display', 'inline-flex');
			};

			toggleBtn.on('click', function () {
				const isExpanded = !block.hasClass('is-expanded');

				block.toggleClass('is-expanded', isExpanded);
				toggleBtn.attr('aria-expanded', isExpanded ? 'true' : 'false');
				toggleText.text(isExpanded ? themeTexts.partnersHide : themeTexts.partnersShow);

				if (!isExpanded) {
					$('html, body').stop().animate({
						scrollTop: block.offset().top
					}, 400);
				}
			});

			updateState();

			$(window).on('resize', updateState);
		},

		initTeamFilter() {
			const $wrap  = $('.team-experts-filter');
			const $btn   = $wrap.find('.team-experts-filter__btn');
			const $label = $wrap.find('.team-experts-filter__label');
			const $items = $wrap.find('.team-experts-filter__item');
			const $cards = $('.team-experts__card');
			const defaultLabel = $label.text();

			$btn.on('click', function(e) {
				e.stopPropagation();
				$wrap.toggleClass('is-open');
			});

			$(document).on('click', function() {
				$wrap.removeClass('is-open');
			});

			$items.on('click', function(e) {
				e.stopPropagation();
				const term = $(this).data('term');

				$items.removeClass('is-active');
				$(this).addClass('is-active');
				$label.text( term === 'all' ? defaultLabel : $(this).text() );
				$wrap.removeClass('is-open');

				if ( term === 'all' ) {
					$cards.css('display', '');
				} else {
					$cards.each(function() {
						const cardTerm = $(this).data('term');
						$(this).css('display', cardTerm === term ? '' : 'none');
					});
				}
			});

			$(document).on('keydown', function(e) {
				if ( e.key === 'Escape' ) {
					$wrap.removeClass('is-open');
				}
			});
		},

		initDonorsMarquee() {
			const lines = document.querySelectorAll('.home-donors__line');

			if (!lines.length) {
				return;
			}

			const marquees = [];
			let rafId = null;
			let lastTime = null;

			lines.forEach((line) => {
				const track = line.querySelector('.home-donors__track');
				const firstSet = line.querySelector('.home-donors__set');

				if (!track || !firstSet) {
					return;
				}

				const marquee = {
					line,
					track,
					firstSet,
					direction: line.dataset.direction === 'right' ? 'right' : 'left',
					speed: parseFloat(line.dataset.speed) || 35,
					setWidth: 0,
					offset: 0,
					isPaused: false,
					isVisible: false
				};

				marquees.push(marquee);
			});

			if (!marquees.length) {
				return;
			}

			const applyTransform = (marquee) => {
				if (!marquee.setWidth) {
					return;
				}

				if (marquee.direction === 'left') {
					marquee.track.style.transform = `translate3d(${-marquee.offset}px, 0, 0)`;
				} else {
					marquee.track.style.transform = `translate3d(${-(marquee.setWidth - marquee.offset)}px, 0, 0)`;
				}
			};

			const updateSizes = () => {
				marquees.forEach((marquee) => {
					marquee.setWidth = marquee.firstSet.scrollWidth;

					if (!marquee.setWidth) {
						return;
					}

					if (marquee.offset >= marquee.setWidth) {
						marquee.offset = marquee.offset % marquee.setWidth;
					}

					applyTransform(marquee);
				});
			};

			const hasActiveMarquees = () => {
				return marquees.some((marquee) => marquee.isVisible && !marquee.isPaused && marquee.setWidth > 0);
			};

			const stopAnimation = () => {
				if (rafId) {
					window.cancelAnimationFrame(rafId);
					rafId = null;
				}
				lastTime = null;
			};

			const animate = (time) => {
				if (lastTime === null) {
					lastTime = time;
				}

				const delta = (time - lastTime) / 1000;
				lastTime = time;

				marquees.forEach((marquee) => {
					if (!marquee.isVisible || marquee.isPaused || !marquee.setWidth) {
						return;
					}

					marquee.offset += marquee.speed * delta;

					if (marquee.offset >= marquee.setWidth) {
						marquee.offset = marquee.offset % marquee.setWidth;
					}

					applyTransform(marquee);
				});

				if (hasActiveMarquees()) {
					rafId = window.requestAnimationFrame(animate);
				} else {
					stopAnimation();
				}
			};

			const startAnimation = () => {
				if (rafId) {
					return;
				}

				lastTime = null;
				rafId = window.requestAnimationFrame(animate);
			};

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					const marquee = marquees.find((item) => item.line === entry.target);

					if (!marquee) {
						return;
					}

					marquee.isVisible = entry.isIntersecting;
				});

				if (hasActiveMarquees()) {
					startAnimation();
				} else {
					stopAnimation();
				}
			}, {
				root: null,
				rootMargin: '100px 0px',
				threshold: 0
			});

			marquees.forEach((marquee) => {
				marquee.line.addEventListener('mouseenter', () => {
					marquee.isPaused = true;

					if (!hasActiveMarquees()) {
						stopAnimation();
					}
				});

				marquee.line.addEventListener('mouseleave', () => {
					marquee.isPaused = false;

					if (marquee.isVisible) {
						startAnimation();
					}
				});

				observer.observe(marquee.line);
			});

			updateSizes();

			window.addEventListener('load', updateSizes);
			window.addEventListener('resize', updateSizes);
		},

		copyToClipboard(text) {
			return navigator.clipboard
				? navigator.clipboard.writeText(text)
				: new Promise((resolve) => {
					const ta = document.createElement('textarea');
					ta.value = text;
					ta.style.cssText = 'position:fixed;opacity:0;';
					document.body.appendChild(ta);
					ta.select();
					document.execCommand('copy');
					document.body.removeChild(ta);
					resolve();
				});
		},

		showTooltipOn($target) {
			if (Scripts.activeTooltip) {
				Scripts.activeTooltip.remove();
				Scripts.activeTooltip = null;
				clearTimeout(Scripts.hideTimer);
			}

			const $tooltip = $(`<span class="copy-tooltip">${themeTexts.copied}</span>`);
			$target.append($tooltip);
			Scripts.activeTooltip = $tooltip;

			setTimeout(() => {
				const rect = $tooltip[0].getBoundingClientRect();
				const vw = window.innerWidth;

				if (rect.right > vw) {
					$tooltip.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
				} else if (rect.left < 0) {
					$tooltip.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
				}

				$tooltip.addClass('copy-tooltip--visible');
			}, 10);

			Scripts.hideTimer = setTimeout(() => {
				$tooltip.removeClass('copy-tooltip--visible');
				setTimeout(() => {
					$tooltip.remove();
					if (Scripts.activeTooltip && Scripts.activeTooltip[0] === $tooltip[0]) {
						Scripts.activeTooltip = null;
					}
				}, 300);
			}, 3500);
		},

		showTooltip($el) {
			Scripts.showTooltipOn($el.find('.js-copy-icon'));
		},

		copyHandler() {
			Scripts.document.on('click', '.js-copy', function (e) {
				e.preventDefault();

				const $el  = $(this);
				const text = $el.data('copy') || $el.text().trim();

				Scripts.copyToClipboard(text).then(() => {
					Scripts.showTooltip($el);
				});
			});
		},

		initFilterToolbarOverflow() {
			const $toolbars = $('.js-filter-toolbar');
			if (!$toolbars.length) return;

			$toolbars.each(function () {
				const $toolbar   = $(this);
				const $buttons   = $toolbar.find('.js-filter-toolbar__buttons');
				const $inner     = $toolbar.find('.js-filter-toolbar__inner');
				const $scrollbar = $toolbar.find('.js-filter-toolbar__scrollbar');
				const $thumb     = $toolbar.find('.js-filter-toolbar__thumb');

				if (!$buttons.length || !$inner.length || !$scrollbar.length || !$thumb.length) return;

				const buttonsEl   = $buttons[0];
				const innerEl     = $inner[0];
				const scrollbarEl = $scrollbar[0];
				const thumbEl     = $thumb[0];

				const checkOverflow = () => {
					$toolbar.removeClass('is-overflow');
					void $toolbar[0].offsetWidth;

					if (innerEl.scrollWidth > $toolbar.width()) {
						$toolbar.addClass('is-overflow');
						updateThumb();
					}
				};

				const updateThumb = () => {
					if (!$toolbar.hasClass('is-overflow')) return;

					const scrollW = buttonsEl.scrollWidth;
					const clientW = buttonsEl.clientWidth;
					const trackW  = scrollbarEl.clientWidth;

					const thumbW = Math.max((clientW / scrollW) * trackW, 30);
					const maxScroll = scrollW - clientW;
					const scrollRatio = maxScroll > 0 ? buttonsEl.scrollLeft / maxScroll : 0;
					const thumbX = scrollRatio * (trackW - thumbW);

					thumbEl.style.width = thumbW + 'px';
					thumbEl.style.transform = 'translateX(' + thumbX + 'px)';
				};

				buttonsEl.addEventListener('scroll', updateThumb);

				// Drag thumb
				let isDragging = false;
				let startX = 0;
				let startScroll = 0;

				thumbEl.addEventListener('mousedown', (e) => {
					isDragging = true;
					startX = e.pageX;
					startScroll = buttonsEl.scrollLeft;
					e.preventDefault();
				});

				document.addEventListener('mousemove', (e) => {
					if (!isDragging) return;

					const scrollW = buttonsEl.scrollWidth;
					const clientW = buttonsEl.clientWidth;
					const trackW  = scrollbarEl.clientWidth;
					const thumbW  = thumbEl.offsetWidth;
					const maxScroll = scrollW - clientW;
					const maxThumb  = trackW - thumbW;

					const deltaX = e.pageX - startX;
					const deltaScroll = (deltaX / maxThumb) * maxScroll;

					buttonsEl.scrollLeft = startScroll + deltaScroll;
				});

				document.addEventListener('mouseup', () => {
					isDragging = false;
				});

				// Click on scrollbar track
				scrollbarEl.addEventListener('click', (e) => {
					if (e.target === thumbEl) return;

					const rect = scrollbarEl.getBoundingClientRect();
					const clickX = e.pageX - rect.left;
					const trackW = scrollbarEl.clientWidth;
					const thumbW = thumbEl.offsetWidth;
					const maxScroll = buttonsEl.scrollWidth - buttonsEl.clientWidth;

					const ratio = (clickX - thumbW / 2) / (trackW - thumbW);
					buttonsEl.scrollLeft = Math.max(0, Math.min(maxScroll, ratio * maxScroll));
				});

				// Drag-to-scroll на самому блоці кнопок
				let isDownButtons = false;
				let startButtonsX = 0;
				let startButtonsScroll = 0;
				let hasMoved = false;

				buttonsEl.addEventListener('mousedown', (e) => {
					if (!$toolbar.hasClass('is-overflow')) return;

					isDownButtons = true;
					hasMoved = false;
					startButtonsX = e.pageX;
					startButtonsScroll = buttonsEl.scrollLeft;
				});

				buttonsEl.addEventListener('mouseleave', () => {
					isDownButtons = false;
				});

				buttonsEl.addEventListener('mouseup', () => {
					isDownButtons = false;
				});

				buttonsEl.addEventListener('mousemove', (e) => {
					if (!isDownButtons) return;

					const walk = e.pageX - startButtonsX;

					if (Math.abs(walk) > 5) {
						hasMoved = true;
					}

					buttonsEl.scrollLeft = startButtonsScroll - walk;
				});

				// Скасовуємо клік на кнопці фільтра, якщо відбувся drag
				buttonsEl.addEventListener('click', (e) => {
					if (hasMoved) {
						e.preventDefault();
						e.stopPropagation();
						hasMoved = false;
					}
				}, true);

				// Wheel — горизонтальна прокрутка
				let wheelTarget = 0;
				let wheelAnimating = false;

				buttonsEl.addEventListener('wheel', (e) => {
					if (!$toolbar.hasClass('is-overflow')) return;

					e.preventDefault();

					wheelTarget += e.deltaY;
					wheelTarget = Math.max(0, Math.min(wheelTarget, buttonsEl.scrollWidth - buttonsEl.clientWidth));

					if (!wheelAnimating) {
						wheelAnimating = true;
						smoothScroll();
					}
				}, { passive: false });

				const smoothScroll = () => {
					const current = buttonsEl.scrollLeft;
					const diff = wheelTarget - current;

					if (Math.abs(diff) < 0.5) {
						buttonsEl.scrollLeft = wheelTarget;
						wheelAnimating = false;
						return;
					}

					buttonsEl.scrollLeft = current + diff * 0.15;
					requestAnimationFrame(smoothScroll);
				};

				// Скрол до активної кнопки при ініціалізації
				const scrollToActive = () => {
					if (!$toolbar.hasClass('is-overflow')) return;

					const $active = $inner.find('.is-active').first();
					if (!$active.length) return;

					const activeEl = $active[0];
					const buttonsRect = buttonsEl.getBoundingClientRect();
					const activeRect  = activeEl.getBoundingClientRect();

					const styles = window.getComputedStyle(buttonsEl);
					const paddingLeft  = parseFloat(styles.paddingLeft)  || 0;
					const paddingRight = parseFloat(styles.paddingRight) || 0;

					const visibleLeft  = buttonsRect.left  + paddingLeft;
					const visibleRight = buttonsRect.right - paddingRight;

					if (activeRect.left >= visibleLeft && activeRect.right <= visibleRight) {
						return;
					}

					buttonsEl.scrollLeft = activeEl.offsetLeft - paddingLeft;
				};

				checkOverflow();
				scrollToActive();

				$(window).on('resize', checkOverflow);

				if (typeof ResizeObserver !== 'undefined') {
					const ro = new ResizeObserver(() => checkOverflow());
					ro.observe(innerEl);
					ro.observe($toolbar[0]);
				}
			});
		},

		initArchiveFilter() {
			const $root = $('.archive-filter:not(.archive-filter--static)');
			if (!$root.length) return;

			const $grid       = $root.find('[data-archive-grid]');
			const $pagination = $root.find('[data-archive-pagination]');
			const $buttons    = $root.find('.archive-filter__btn');
			const $sortBtns   = $root.find('.archive-filter__sort-btn');

			const config = {
				postType:    $root.data('post-type'),
				taxonomy:    $root.data('taxonomy'),
				archiveSlug: $root.data('archive-slug') || $root.data('post-type'),
				queryVar:    $root.data('query-var')    || $root.data('taxonomy'),
				excludeTerm: $root.data('exclude-term') || 0,
				perPage:     $root.data('per-page') || 12,
			};

			const updateUrl = () => {
				const term  = $buttons.filter('.is-active').data('term');
				const order = $sortBtns.filter('.is-active').data('order');

				const langPrefix = lang !== 'uk' ? '/' + lang : '';
				const params = new URLSearchParams();

				if (term && term !== 'all') {
					params.set(config.queryVar, term);
				}
				if (order === 'asc') {
					params.set('order', 'asc');
				}

				const query = params.toString();
				const url = window.location.origin + langPrefix + '/' + config.archiveSlug + '/' + (query ? '?' + query : '');

				window.history.replaceState({}, '', url);
			};

			const fetchPosts = () => {
				const term  = $buttons.filter('.is-active').data('term');
				const order = $sortBtns.filter('.is-active').data('order');

				$grid.addClass('is-loading');

				$.post(ajaxurl, {
					action:       'th_archive_filter',
					post_type:    config.postType,
					taxonomy:     config.taxonomy,
					exclude_term: config.excludeTerm,
					per_page:     config.perPage,
					term:         term,
					order:        order,
					lang:         typeof lang !== 'undefined' ? lang : '',
				}, (response) => {
					if (response.success) {
						$grid.html(response.data.posts).removeClass('is-loading');
						$pagination.html(response.data.pagination || '');
					}
				}, 'json');
			};

			$root.on('click', '.archive-filter__btn', function () {
				$buttons.removeClass('is-active');
				$(this).addClass('is-active');
				updateUrl();
				fetchPosts();
			});

			$root.on('click', '.archive-filter__sort-btn', function () {
				$sortBtns.removeClass('is-active');
				$(this).addClass('is-active');
				updateUrl();
				fetchPosts();
			});

			$root.on('click', '[data-archive-pagination] a', function () {
				$('html, body').animate({ scrollTop: $root.offset().top - 80 }, 300);
			});
		},

		initArchiveFilterStatic() {
			const $root = $('.archive-filter--static');
			if (!$root.length) return;

			const $buttons = $root.find('.archive-filter__btn');
			const $cards   = $root.find('[data-terms]');

			const config = {
				postType:    $root.data('post-type'),
				taxonomy:    $root.data('taxonomy'),
				archiveSlug: $root.data('archive-slug'),
				queryVar:    $root.data('query-var'),
			};

			const updateUrl = () => {
				const term = $buttons.filter('.is-active').data('term');

				const langPrefix = lang !== 'uk' ? '/' + lang : '';
				const params = new URLSearchParams();

				if (term && term !== 'all') {
					params.set(config.queryVar, term);
				}

				const query = params.toString();
				const url = window.location.origin + langPrefix + '/' + config.archiveSlug + '/' + (query ? '?' + query : '');

				window.history.replaceState({}, '', url);
			};

			const applyFilter = () => {
				const term = $buttons.filter('.is-active').data('term');
				if (!term || term === 'all') {
					$cards.removeClass('is-hidden');
					return;
				}
				$cards.each(function () {
					const terms = ($(this).attr('data-terms') || '').split(' ').filter(Boolean);
					$(this).toggleClass('is-hidden', !terms.includes(term));
				});
			};

			$root.on('click', '.archive-filter__btn', function () {
				$buttons.removeClass('is-active');
				$(this).addClass('is-active');
				updateUrl();
				applyFilter();
			});

			applyFilter();
		},

		justiceMapNavScroll() {
			$('.justice-map-nav__link.is-active')[0]?.scrollIntoView({
				behavior: 'smooth',
				inline: 'center',
				block: 'nearest',
			});
		},

		initVerticalScrollbars() {
			const $roots = $('.js-vscrollbar');
			if (!$roots.length) return;

			$roots.each(function () {
				const $root     = $(this);
				const $viewport = $root.find('.js-vscrollbar__viewport').first();
				const $track    = $root.find('.js-vscrollbar__track').first();
				const $thumb    = $root.find('.js-vscrollbar__thumb').first();
				if (!$viewport.length || !$track.length || !$thumb.length) return;

				const viewportEl = $viewport[0];
				const trackEl    = $track[0];
				const thumbEl    = $thumb[0];

				const MIN_THUMB = 30;
				let rafId = null;

				const updateThumb = () => {
					rafId = null;
					const scrollH = viewportEl.scrollHeight;
					const clientH = viewportEl.clientHeight;
					const trackH  = trackEl.clientHeight;

					if (scrollH <= clientH + 1) {
						$track.removeClass('is-visible');
						$root.removeClass('is-at-bottom');
						return;
					}

					$track.addClass('is-visible');

					const thumbH = Math.max((clientH / scrollH) * trackH, MIN_THUMB);
					const maxScroll = scrollH - clientH;
					const thumbY = maxScroll > 0
						? (viewportEl.scrollTop / maxScroll) * (trackH - thumbH)
						: 0;

					thumbEl.style.height = thumbH + 'px';
					thumbEl.style.transform = 'translateY(' + thumbY + 'px)';
					$root.toggleClass('is-at-bottom', viewportEl.scrollTop + clientH >= scrollH - 2);
				};

				// rAF-тротлінг — не частіше ніж один раз на кадр
				const scheduleUpdate = () => {
					if (rafId === null) rafId = requestAnimationFrame(updateThumb);
				};

				// --- Drag thumb ---
				let drag = null;

				$thumb.on('mousedown', (e) => {
					e.preventDefault();
					const maxScroll = viewportEl.scrollHeight - viewportEl.clientHeight;
					const maxThumb  = trackEl.clientHeight - thumbEl.offsetHeight;
					drag = {
						startY: e.pageY,
						startScroll: viewportEl.scrollTop,
						ratio: maxThumb > 0 ? maxScroll / maxThumb : 0,
					};
					document.body.style.userSelect = 'none';
				});

				$(document).on('mousemove', (e) => {
					if (!drag) return;
					viewportEl.scrollTop = drag.startScroll + (e.pageY - drag.startY) * drag.ratio;
				});

				$(document).on('mouseup', () => {
					if (!drag) return;
					drag = null;
					document.body.style.userSelect = '';
				});

				// --- Клік по треку (не по thumb) ---
				$track.on('click', (e) => {
					if (e.target === thumbEl) return;
					const trackH = trackEl.clientHeight;
					const thumbH = thumbEl.offsetHeight;
					const maxScroll = viewportEl.scrollHeight - viewportEl.clientHeight;
					const clickY = e.clientY - trackEl.getBoundingClientRect().top;
					const ratio = (clickY - thumbH / 2) / (trackH - thumbH);
					viewportEl.scrollTop = Math.max(0, Math.min(maxScroll, ratio * maxScroll));
				});

				$viewport.on('scroll', scheduleUpdate);
				$(window).on('resize', scheduleUpdate);

				if (typeof ResizeObserver !== 'undefined') {
					const ro = new ResizeObserver(scheduleUpdate);
					ro.observe(viewportEl);
					if (viewportEl.firstElementChild) {
						ro.observe(viewportEl.firstElementChild);
					}
				}

				updateThumb();
			});
		},

		initJusticeMapScrollSpy() {
			const $layout = $('.justice-map-tax-content__layout');
			if (!$layout.length) return;

			const $sidebar      = $layout.find('.justice-map-sidebar');
			const $sidebarLinks = $layout.find('.justice-map-sidebar__link');
			const $sidebarScroll = $layout.find('.justice-map-sidebar__scroll');
			const $postsScroll  = $layout.find('.justice-map-posts__scroll');
			const $posts        = $layout.find('.justice-map-post');

			if (!$postsScroll.length || !$posts.length) return;

			const postsScrollEl = $postsScroll[0];

			let isScrollingByClick = false;
			let clickTimeoutId = null;

			// --- Активна кнопка ---
			const setActiveLink = (anchor) => {
				$sidebarLinks.each(function () {
					const $link = $(this);
					$link.toggleClass('is-active', $link.attr('data-target') === anchor);
				});

				// Скрол сайдбара до активної кнопки.
				const $active = $sidebarLinks.filter('.is-active').first();
				if ($active.length) {
					$active[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
				}
			};

			// --- Зміна хеша в URL без перезавантаження ---
			const updateHash = (anchor) => {
				const newHash = '#' + anchor;
				if (window.location.hash !== newHash) {
					history.replaceState(null, '', window.location.pathname + window.location.search + newHash);
				}
			};

			// --- Прибирання hash #justice-map-content після першого доскролу до блоку ---
			const cleanupContentHash = () => {
				if (window.location.hash === '#justice-map-content') {
					history.replaceState(null, '', window.location.pathname + window.location.search);
				}
			};

			// --- IntersectionObserver на постах ---
			const observer = new IntersectionObserver((entries) => {
				if (isScrollingByClick) return;

				// Беремо ті, що зараз перетинають тригерну смугу.
				const visible = entries.filter(e => e.isIntersecting);
				if (!visible.length) return;

				// Якщо їх кілька — беремо самий верхній (найменший top).
				visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
				const target = visible[0].target;
				const anchor = target.getAttribute('data-anchor');
				if (!anchor) return;

				setActiveLink(anchor);
				updateHash(anchor);
			}, {
				root: postsScrollEl,
				rootMargin: '-20% 0px -75% 0px',
				threshold: 0,
			});

			$posts.each(function () {
				observer.observe(this);
			});

			// --- Клік по кнопці сайдбара ---
			$sidebarLinks.on('click', function (e) {
				e.preventDefault();

				const $link = $(this);
				const anchor = $link.attr('data-target');
				if (!anchor) return;

				const target = document.getElementById(anchor);
				if (!target) return;

				// Активуємо кнопку зразу.
				$sidebarLinks.removeClass('is-active');
				$link.addClass('is-active');

				// Блокуємо observer.
				isScrollingByClick = true;

				// Скрол всередині контейнера контенту.
				const targetTop = target.offsetTop - postsScrollEl.offsetTop;
				postsScrollEl.scrollTo({
					top: targetTop,
					behavior: 'smooth',
				});

				// Хеш в URL.
				updateHash(anchor);

				// Скрол сайдбара (на адаптиві може теж знадобитись підтягнути).
				$link[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });

				// Розблоковуємо observer після завершення скрола.
				clearTimeout(clickTimeoutId);

				const onScrollEnd = () => {
					isScrollingByClick = false;
					postsScrollEl.removeEventListener('scrollend', onScrollEnd);
				};

				if ('onscrollend' in window) {
					postsScrollEl.addEventListener('scrollend', onScrollEnd);
					// Підстраховка на випадок, якщо scrollend не прилетить (Safari < 18).
					clickTimeoutId = setTimeout(() => {
						isScrollingByClick = false;
						postsScrollEl.removeEventListener('scrollend', onScrollEnd);
					}, 1000);
				} else {
					// Старі браузери — фолбек на таймер.
					clickTimeoutId = setTimeout(() => {
						isScrollingByClick = false;
					}, 600);
				}
			});

			// --- Переривання програмного скрола користувачем ---
			const interruptProgrammaticScroll = () => {
				if (isScrollingByClick) {
					isScrollingByClick = false;
					clearTimeout(clickTimeoutId);
				}
			};

			postsScrollEl.addEventListener('wheel', interruptProgrammaticScroll, { passive: true });
			postsScrollEl.addEventListener('touchstart', interruptProgrammaticScroll, { passive: true });

			const $postsThumb = $('.justice-map-posts .js-vscrollbar__thumb');
			if ($postsThumb.length) {
				$postsThumb[0].addEventListener('mousedown', interruptProgrammaticScroll);
			}

			// --- Обробка хеша при завантаженні сторінки ---
			const handleInitialHash = () => {
				const savedPostHash = window.__justiceMapPostHash;

				// Якщо ранній скрипт перехопив якір поста — обробляємо його.
				if (savedPostHash && savedPostHash.startsWith('#jm-post-')) {
					const anchor = savedPostHash.slice(1);
					delete window.__justiceMapPostHash;

					const target = document.getElementById(anchor);
					if (!target) {
						// Поста немає (можливо, не пройшов фільтр) — просто чистимо хеш.
						setTimeout(cleanupContentHash, 100);
						return;
					}

					isScrollingByClick = true;

					// Миттєво ставимо внутрішній скрол контейнера постів на потрібний пост.
					const targetTop = target.offsetTop - postsScrollEl.offsetTop;
					postsScrollEl.scrollTo({ top: targetTop, behavior: 'instant' });

					setActiveLink(anchor);

					// Повертаємо в URL якір поста (зараз там #justice-map-content).
					history.replaceState(null, '', window.location.pathname + window.location.search + '#' + anchor);

					setTimeout(() => { isScrollingByClick = false; }, 100);
					return;
				}

				// Випадок: хеш на блок контенту — anchorScroll вже доскролив, прибираємо хеш.
				if (window.location.hash === '#justice-map-content') {
					setTimeout(cleanupContentHash, 100);
					return;
				}

				// Випадок: хеш на пост, але без перехоплення (наприклад, клік всередині сторінки).
				if (window.location.hash && window.location.hash.startsWith('#jm-post-')) {
					const anchor = window.location.hash.slice(1);
					const target = document.getElementById(anchor);
					if (!target) return;

					isScrollingByClick = true;
					const targetTop = target.offsetTop - postsScrollEl.offsetTop;
					postsScrollEl.scrollTo({ top: targetTop, behavior: 'instant' });
					setActiveLink(anchor);
					setTimeout(() => { isScrollingByClick = false; }, 100);
				}
			};

			handleInitialHash();
		},

		initJusticeMapSidebarToggle() {
			const $layout = $('.justice-map-tax-content__layout');
			if (!$layout.length) return;

			const $toggle  = $layout.find('.js-jm-sidebar-toggle');
			const $wrap    = $layout.find('.js-jm-sidebar-wrap');
			const $sidebar = $layout.find('.js-jm-sidebar');
			if (!$toggle.length || !$wrap.length || !$sidebar.length) return;

			const toggleEl = $toggle[0];
			const wrapEl   = $wrap[0];

			const isOpen = () => $wrap.hasClass('is-open');

			const scrollActiveIntoView = () => {
				const $active = $sidebar.find('.justice-map-sidebar__link.is-active').first();
				if (!$active.length) return;
				const $scrollEl = $sidebar.find('.justice-map-sidebar__scroll').first();
				if (!$scrollEl.length) return;

				const scrollEl = $scrollEl[0];
				const activeEl = $active[0];
				const targetTop = activeEl.offsetTop - scrollEl.clientHeight / 2 + activeEl.offsetHeight / 2;
				scrollEl.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
			};

			const open = () => {
				$wrap.addClass('is-open');
				$toggle.addClass('is-open').attr('aria-expanded', 'true');
				requestAnimationFrame(scrollActiveIntoView);
			};

			const close = () => {
				$wrap.removeClass('is-open');
				$toggle.removeClass('is-open').attr('aria-expanded', 'false');
			};

			$toggle.on('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				isOpen() ? close() : open();
			});

			document.addEventListener('click', (e) => {
				if (!isOpen()) return;
				if (wrapEl.contains(e.target)) return;
				if (toggleEl.contains(e.target)) return;
				close();
			});

			$sidebar.on('click', '.justice-map-sidebar__link', () => {
				setTimeout(close, 0);
			});

			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && isOpen()) close();
			});
		},

		// =============================================================================
		// createInteractiveMap — універсальна функція інтерактивної SVG-мапи.
		// Відповідає за: підсвічування країн, zoom/pan, обмеження viewBox.
		// Не знає, що робити при кліку на країну — викликає callback з config.
		// =============================================================================

		createInteractiveMap(rootEl, config) {
			if (!rootEl) return null;
			const svg = rootEl.querySelector('#world');
			if (!svg) return null;

			const wrap = rootEl.querySelector('[data-map-wrap]');
			if (!wrap) return null;

			const NATIVE_W = 652.83;
			const NATIVE_H = 308.37;
			const ZOOM_STEP = 1.4;
			const MIN_W = 40;

			const available = Array.isArray(config.available) ? config.available : [];
			const active = config.active || '';
			const onCountryClick = typeof config.onCountryClick === 'function' ? config.onCountryClick : null;

			// -------------------------------------------------------------------------
			// Класи на країнах
			// -------------------------------------------------------------------------

			available.forEach(iso => {
				const path = svg.querySelector('#' + iso);
				if (path) path.classList.add('is-available');
			});
			if (active) {
				const path = svg.querySelector('#' + active);
				if (path) path.classList.add('is-active');
			}

			// -------------------------------------------------------------------------
			// ViewBox: стан і обмеження
			// -------------------------------------------------------------------------

			let vb = { x: 0, y: 0, w: NATIVE_W, h: NATIVE_H };

			const clampViewBox = (next) => {
				if (next.w > NATIVE_W) {
					const r = NATIVE_W / next.w;
					next.w *= r;
					next.h *= r;
				}
				if (next.h > NATIVE_H) {
					const r = NATIVE_H / next.h;
					next.w *= r;
					next.h *= r;
				}
				if (next.w < MIN_W) {
					const r = MIN_W / next.w;
					next.w *= r;
					next.h *= r;
				}

				const unitsPerPx = Math.min(next.w / wrap.clientWidth, next.h / wrap.clientHeight);
				const visibleW = wrap.clientWidth * unitsPerPx;
				const visibleH = wrap.clientHeight * unitsPerPx;
				const offsetX = (next.w - visibleW) / 2;
				const offsetY = (next.h - visibleH) / 2;

				const minX = -offsetX;
				const maxX = NATIVE_W - visibleW - offsetX;
				const minY = -offsetY;
				const maxY = NATIVE_H - visibleH - offsetY;

				if (next.x < minX) next.x = minX;
				if (next.x > maxX) next.x = maxX;
				if (next.y < minY) next.y = minY;
				if (next.y > maxY) next.y = maxY;

				return next;
			};

			const applyViewBox = () => {
				vb = clampViewBox(vb);
				svg.setAttribute('viewBox', `${vb.x} ${vb.y} ${vb.w} ${vb.h}`);
			};

			const readDefaultViewBox = () => {
				const styles = getComputedStyle(wrap);
				const x = parseFloat(styles.getPropertyValue('--vb-x'));
				const y = parseFloat(styles.getPropertyValue('--vb-y'));
				const w = parseFloat(styles.getPropertyValue('--vb-w'));
				const h = parseFloat(styles.getPropertyValue('--vb-h'));
				if (!isNaN(x) && !isNaN(y) && !isNaN(w) && !isNaN(h)) {
					vb = { x, y, w, h };
				}
			};

			const zoomToCountry = (iso, padding = 30) => {
				const path = svg.querySelector('#' + iso);
				if (!path) return false;

				const bbox = path.getBBox();
				const wrapRatio = wrap.clientWidth / wrap.clientHeight;

				let w = bbox.width + padding * 2;
				let h = bbox.height + padding * 2;

				if (w / h > wrapRatio) {
					h = w / wrapRatio;
				} else {
					w = h * wrapRatio;
				}

				vb = {
					x: bbox.x + bbox.width / 2 - w / 2,
					y: bbox.y + bbox.height / 2 - h / 2,
					w: w,
					h: h,
				};
				return true;
			};

			// Стартовий стан
			if (active && zoomToCountry(active)) {
				applyViewBox();
			} else {
				readDefaultViewBox();
				applyViewBox();
			}

			let resizeTimeout;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => {
					if (active && zoomToCountry(active)) {
						applyViewBox();
					} else {
						readDefaultViewBox();
						applyViewBox();
					}
				}, 150);
			});

			// -------------------------------------------------------------------------
			// Zoom buttons
			// -------------------------------------------------------------------------

			const zoomBy = (factor) => {
				const cx = vb.x + vb.w / 2;
				const cy = vb.y + vb.h / 2;

				let newW = vb.w / factor;
				let newH = vb.h / factor;

				if (newW < MIN_W) {
					const r = MIN_W / newW;
					newW *= r;
					newH *= r;
				}
				if (newW > NATIVE_W) {
					const r = NATIVE_W / newW;
					newW *= r;
					newH *= r;
				}
				if (newH > NATIVE_H) {
					const r = NATIVE_H / newH;
					newW *= r;
					newH *= r;
				}

				vb.w = newW;
				vb.h = newH;
				vb.x = cx - vb.w / 2;
				vb.y = cy - vb.h / 2;

				applyViewBox();
			};

			rootEl.querySelectorAll('[data-action="zoom-in"]').forEach(btn => {
				btn.addEventListener('click', () => zoomBy(ZOOM_STEP));
			});
			rootEl.querySelectorAll('[data-action="zoom-out"]').forEach(btn => {
				btn.addEventListener('click', () => zoomBy(1 / ZOOM_STEP));
			});

			// -------------------------------------------------------------------------
			// Wheel zoom (Ctrl/Cmd + колесо) — як на Google Maps
			// -------------------------------------------------------------------------

			// Допоміжна функція: зум з центруванням на точці курсора.
			// clientX/clientY — координати курсора відносно viewport браузера.
			const zoomByAtPoint = (factor, clientX, clientY) => {
				// Поточна точка в координатах SVG, на яку наведений курсор
				const rect = wrap.getBoundingClientRect();
				const unitsPerPxX = vb.w / rect.width;
				const unitsPerPxY = vb.h / rect.height;
				const pointX = vb.x + (clientX - rect.left) * unitsPerPxX;
				const pointY = vb.y + (clientY - rect.top) * unitsPerPxY;

				// Нові розміри viewBox з тими ж обмеженнями, що і в zoomBy
				let newW = vb.w / factor;
				let newH = vb.h / factor;

				if (newW < MIN_W) {
					const r = MIN_W / newW;
					newW *= r;
					newH *= r;
				}
				if (newW > NATIVE_W) {
					const r = NATIVE_W / newW;
					newW *= r;
					newH *= r;
				}
				if (newH > NATIVE_H) {
					const r = NATIVE_H / newH;
					newW *= r;
					newH *= r;
				}

				// Скільки відсотків від ширини/висоти viewBox займає курсор зліва/зверху —
				// це співвідношення треба зберегти після зуму, щоб точка під курсором лишилась на місці.
				const ratioX = (pointX - vb.x) / vb.w;
				const ratioY = (pointY - vb.y) / vb.h;

				vb.w = newW;
				vb.h = newH;
				vb.x = pointX - newW * ratioX;
				vb.y = pointY - newH * ratioY;

				applyViewBox();
			};

			wrap.addEventListener('wheel', (e) => {
				// Зумимо тільки при затиснутому Ctrl (Windows/Linux) або Cmd (Mac).
				// Без модифікатора — лишаємо нативний скрол сторінки.
				if (!e.ctrlKey && !e.metaKey) return;

				e.preventDefault();

				// deltaY > 0 — колесо вниз — зменшення (як у Google Maps).
				// deltaY < 0 — колесо вгору — збільшення.
				const factor = e.deltaY < 0 ? ZOOM_STEP : 1 / ZOOM_STEP;

				zoomByAtPoint(factor, e.clientX, e.clientY);
			}, { passive: false });

			// -------------------------------------------------------------------------
			// Pan (mouse + touch)
			// -------------------------------------------------------------------------

			let isDragging = false;
			let dragMoved = false;
			let dragStart = null;

			const startDrag = (clientX, clientY) => {
				isDragging = true;
				dragMoved = false;
				dragStart = { clientX, clientY, vbX: vb.x, vbY: vb.y };
				wrap.classList.add('is-dragging');
			};

			const moveDrag = (clientX, clientY) => {
				if (!isDragging || !dragStart) return;
				const dxPx = clientX - dragStart.clientX;
				const dyPx = clientY - dragStart.clientY;
				if (Math.abs(dxPx) > 3 || Math.abs(dyPx) > 3) {
					dragMoved = true;
				}
				const unitsPerPx = Math.min(vb.w / wrap.clientWidth, vb.h / wrap.clientHeight);
				vb.x = dragStart.vbX - dxPx * unitsPerPx;
				vb.y = dragStart.vbY - dyPx * unitsPerPx;
				applyViewBox();
			};

			const endDrag = () => {
				isDragging = false;
				dragStart = null;
				wrap.classList.remove('is-dragging');
			};

			wrap.addEventListener('mousedown', (e) => {
				if (e.target.closest('[data-action]')) return;
				e.preventDefault();
				startDrag(e.clientX, e.clientY);
			});

			window.addEventListener('mousemove', (e) => {
				if (isDragging) moveDrag(e.clientX, e.clientY);
			});

			window.addEventListener('mouseup', endDrag);

			wrap.addEventListener('touchstart', (e) => {
				if (e.touches.length !== 1) return;
				if (e.target.closest('[data-action]')) return;
				const t = e.touches[0];
				startDrag(t.clientX, t.clientY);
			}, { passive: true });

			wrap.addEventListener('touchmove', (e) => {
				if (!isDragging || e.touches.length !== 1) return;
				e.preventDefault();
				const t = e.touches[0];
				moveDrag(t.clientX, t.clientY);
			}, { passive: false });

			wrap.addEventListener('touchend', endDrag);
			wrap.addEventListener('touchcancel', endDrag);

			// -------------------------------------------------------------------------
			// Кліки по доступних країнах — викликаємо callback
			// -------------------------------------------------------------------------

			if (onCountryClick) {
				svg.addEventListener('click', (e) => {
					if (dragMoved) return;
					const path = e.target.closest('path.is-available');
					if (!path) return;
					const iso = path.id;
					if (!iso) return;
					onCountryClick(iso);
				});
			}

			// Повертаємо API на випадок, якщо знадобиться зовні
			return {
				zoomToCountry: (iso) => {
					if (zoomToCountry(iso)) applyViewBox();
				},
				resetView: () => {
					readDefaultViewBox();
					applyViewBox();
				},
			};
		},

		// =============================================================================
		// initJusticeMapUniversal — обгортка для сторінки юрисдикції.
		// =============================================================================

		initJusticeMapUniversal() {
			const root = document.querySelector('.justice-map-universal');
			if (!root) return;

			// Прибираємо хеш #justice-map-content після доскролу.
			if (window.location.hash === '#justice-map-content') {
				setTimeout(() => {
					history.replaceState(null, '', window.location.pathname + window.location.search);
				}, 100);
			}

			const available = (root.dataset.available || '').split(',').filter(Boolean);
			const active = root.dataset.active || '';
			const baseUrl = window.location.pathname;

			// Контейнер з viewBox-сетингом і pan-зоною.
			this.createInteractiveMap(root, {
				available,
				active,
				onCountryClick: (iso) => {
					window.location.href = baseUrl + '?country=' + encodeURIComponent(iso) + '#justice-map-content';
				},
			});
		},

		// =============================================================================
		// initWorldMapCards — обгортка для секцій карти з картками.
		// =============================================================================

		initWorldMapCards() {
			const roots = document.querySelectorAll('.world-map-cards');
			if (!roots.length) return;

			roots.forEach(root => {
				const available = (root.dataset.available || '').split(',').filter(Boolean);

				const showPanel = (iso) => {
					// Зняти is-active з усіх панелей.
					root.querySelectorAll('.world-map-cards__panel').forEach(p => {
						p.classList.remove('is-active');
					});

					const panel = root.querySelector(`.world-map-cards__panel[data-country="${iso}"]`);
					if (!panel) return false;

					panel.classList.add('is-active');
					root.classList.add('has-active-country');

					// Активний клас на країні в SVG.
					const svg = root.querySelector('#world');
					if (svg) {
						svg.querySelectorAll('path.is-active').forEach(p => p.classList.remove('is-active'));
						const path = svg.querySelector('#' + iso);
						if (path) path.classList.add('is-active');
					}

					// На мобілі — проскролити сторінку так, щоб низ панелі був на 15px від низу екрану.
					if (window.matchMedia('(max-width: 767px)').matches) {
						// Чекаємо кадр щоб панель встигла відмалюватись з її висотою.
						requestAnimationFrame(() => {
							const rect = panel.getBoundingClientRect();
							const panelBottomInPage = rect.bottom + window.scrollY;
							const targetScroll = panelBottomInPage - window.innerHeight + 15;

							window.scrollTo({
								top: targetScroll,
								behavior: 'smooth',
							});
						});
					}

					return true;
				};

				// Закрити активну панель.
				const hidePanel = () => {
					if (!root.classList.contains('has-active-country')) return;

					root.querySelectorAll('.world-map-cards__panel.is-active').forEach(p => {
						p.classList.remove('is-active');
					});
					root.classList.remove('has-active-country');
					const svg = root.querySelector('#world');
					if (svg) {
						svg.querySelectorAll('path.is-active').forEach(p => p.classList.remove('is-active'));
					}
				};

				this.createInteractiveMap(root, {
					available,
					active: null,
					onCountryClick: (iso) => {
						showPanel(iso);
					},
				});

				// ---------------------------------------------------------------------
				// Закриття по кліку поза карточками
				// ---------------------------------------------------------------------

				// Запам'ятовуємо точку натискання, щоб відрізнити клік від drag
				// (pan карти, перетягування скролбару панелі).
				let downPoint = null;
				document.addEventListener('pointerdown', (e) => {
					downPoint = { x: e.clientX, y: e.clientY };
				}, true);

				document.addEventListener('click', (e) => {
					if (!root.classList.contains('has-active-country')) return;

					// Був drag, а не клік — ігноруємо.
					// e.detail === 0 — клік з клавіатури, координат немає.
					if (e.detail !== 0 && downPoint) {
						const dx = Math.abs(e.clientX - downPoint.x);
						const dy = Math.abs(e.clientY - downPoint.y);
						if (dx > 5 || dy > 5) return;
					}

					const target = e.target;
					if (!(target instanceof Element)) return;

					// Клік всередині карточок.
					if (target.closest('.world-map-cards__panel')) return;

					// Кнопки зуму.
					if (target.closest('[data-action]')) return;

					// Клік по доступній країні — її обробляє onCountryClick (перемикання панелі).
					if (root.contains(target) && target.closest('path.is-available')) return;

					hidePanel();
				});

				// Закриття по Esc.
				document.addEventListener('keydown', (e) => {
					if (e.key === 'Escape') hidePanel();
				});

			});
		},

		// --- Таби валют (існують лише коли валют більше однієї) ---
		initSupportCurrencies() {
			const $roots = $('.js-support-currencies');
			if (!$roots.length) return;

			$roots.each(function () {
				const $root   = $(this);
				const $tabs   = $root.find('.js-currency-tab');
				const $panels = $root.find('.js-currency-panel');

				if (!$tabs.length) return; // одна валюта — перемикати нічого

				$tabs.on('click', function () {
					const target = $(this).data('target');

					$tabs.removeClass('is-active').attr('aria-selected', 'false');
					$(this).addClass('is-active').attr('aria-selected', 'true');

					$panels.each(function () {
						const $panel = $(this);
						const match  = $panel.attr('id') === target;

						$panel.toggleClass('is-active', match);
						if (match) {
							$panel.removeAttr('hidden');
						} else {
							$panel.attr('hidden', 'hidden');
						}
					});
				});
			});
		},

		initCopyAllRequisites() {
			Scripts.document.on('click', '.js-copy-all', function (e) {
				e.preventDefault();

				const $btn   = $(this);
				const $panel = $btn.closest('[data-currency-panel]');
				if (!$panel.length) return;

				const lines = $panel.find('.js-req-row').toArray().map((row) => {
					const label = (row.dataset.label || '').trim();
					const value = (row.dataset.value || '').trim();
					return label ? `${label}: ${value}` : value;
				}).filter(Boolean);

				if (!lines.length) return;

				Scripts.copyToClipboard(lines.join('\n')).then(() => {
					Scripts.showTooltipOn($btn);
				});
			});
		},

		init() {
			this.varInit();
			this.setTopBarHeight();
			this.stickyHeader();
			if ($('body').hasClass('single')) {
				this.scrollProgressBar();
			}
			this.scrollToTopBtn();
			this.headerOverlays();
			this.mobileSubmenu();
			this.menuHashActiveState();
			if ($('#search-archive-popup.header-search--compendium').length) {
				this.initCompendiumSearch();
			}

			this.anchorScroll();

			if ($('.th-toc-fab').length) {
				this.tocFab();
			}

			if ( $('.js-home-areas-media').length ) {
				this.initHomeAreasHover();
			}

			if ( $('.awards-slider').length ) {
				this.homeAwardsSlider();
			}

			this.counterInit();
			this.marqueeScrollInit();

			if ( $('.home-partners').length ) {
				this.initHomePartnersToggle();
			}
			if ( $('.home-donors__lists').length ) {
				this.initDonorsMarquee();
			}

			if ($('.team-experts-filter').length) {
				this.initTeamFilter();
			}

			if ($('.js-copy').length) {
				this.copyHandler();
			}

			if ($('.js-filter-toolbar').length) {
				this.initFilterToolbarOverflow();
			}
			if ($('.archive-filter:not(.archive-filter--static)').length) {
				this.initArchiveFilter();
			}
			if ($('.archive-filter--static').length) {
				this.initArchiveFilterStatic();
			}

			if ($('.justice-map-nav').length) {
				this.justiceMapNavScroll();
			}
			
			if ($('.js-vscrollbar').length) {
				this.initVerticalScrollbars();
			}

			if ($('.justice-map-tax-content__layout').length) {
				this.initJusticeMapScrollSpy();
				this.initJusticeMapSidebarToggle();
			}

			if ($('.justice-map-universal').length) {
				this.initJusticeMapUniversal();
			}

			if ($('.world-map-cards').length) {
				this.initWorldMapCards();
			}

			if ($('.js-support-currencies').length) {
				this.initSupportCurrencies();
				this.initCopyAllRequisites();
			}

		},
	};

	$(document).ready(function () {
		Scripts.init();
	});
});